import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this);
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden");
    document.addEventListener("click", this.closeOnClickOutside);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    document.removeEventListener("click", this.closeOnClickOutside);
  }

  hide(event) {
    if (event && this.element.contains(event.target)) return;
    this.close();
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside);
  }
}
